export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const SET_SIDEBAR_POSITION = 'SET_SIDEBAR_POSITION';
export const SIDEBAR_ERROR = 'SIDEBAR_ERROR';


export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';


export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const UTENTE_ERROR = 'UTENTE_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAN_DATI_DASHBOARD = 'CLEAN_DATI_DASHBOARD';
export const RECUPERA_PASSWORD = 'RECUPERA_PASSWORD';
export const CHECK_TOKEN = 'CHECK_TOKEN';
export const MODIFICA_PASSWORD = 'MODIFICA_PASSWORD';
export const MODIFICA_PROFILO = 'MODIFICA_PROFILO';
export const GET_UTENTI = 'GET_UTENTI';
export const AGGIUNGI_UTENTE = 'AGGIUNGI_UTENTE';
export const GET_UTENTE = 'GET_UTENTE';
export const MODIFICA_UTENTE = 'MODIFICA_UTENTE';


export const GET_EVENTI_AGENDA = 'GET_EVENTI_AGENDA';
export const GET_EVENTO_AGENDA = 'GET_EVENTO_AGENDA';
export const GET_EVENTO_AGENDA_STATISTICHE = 'GET_EVENTO_AGENDA_STATISTICHE';
export const AGGIUNGI_EVENTO = 'AGGIUNGI_EVENTO';
export const MODIFICA_EVENTO = 'MODIFICA_EVENTO';
export const ELIMINA_EVENTO = 'ELIMINA_EVENTO';
export const AGENDA_ERROR = 'AGENDA_ERROR';

export const GET_AUDIO = 'GET_AUDIO';
export const GET_AUDIOS = 'GET_AUDIOS';
export const AGGIUNGI_AUDIO = 'AGGIUNGI_AUDIO';
export const MODIFICA_AUDIO = 'MODIFICA_AUDIO';
export const ELIMINA_AUDIO = 'ELIMINA_AUDIO';
export const AUDIO_ERROR = 'AUDIO_ERROR';
